import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Space } from "antd";

import useQuery from "../../../../hooks/useQuery";
import {
  getGraphDataAPI,
  getScalesDataAPI,
} from "../../../../services/physio.services";
import ScaleModal from "./ScaleModal";
import scalesConfig from "../../../../helpers/physioscaleskeys";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import LoadingOverlay from "../../../Loaders/LoadingOverlay";
import { UiButton, UiSectionCard } from "../../../ui";
import "./progressScales.css";

const ProgressScales = ({ patientData }) => {
  const params = useQuery();
  const admissionId = params?.patient;

  const [scalesData, setScalesData] = useState([]);
  const [selectedScale, setSelectedScale] = useState(null);
  const [selectedScaleData, setSelectedScaleData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scaleLoading, setscaleLoading] = useState(false);

  const handleBtnClick = useMemo(
    () => (key) => {
      setSelectedScale(key);
      setscaleLoading(true);
      getGraphDataAPI(admissionId, key)
        .then((res) => {
          setSelectedScaleData(res?.data?.data);
          setIsModalVisible(true);
        })
        .catch((error) => console.error("Error fetching scale data:", error))
        .finally(() => setscaleLoading(false));
    },
    [admissionId]
  );

  const getScalesData = () => {
    setLoading(true);
    getScalesDataAPI(admissionId)
      .then((res) => {
        const mappedData = res?.data?.data?.map((item) => ({
          ...item,
          displayKey: scalesConfig[item?.key]?.shortName || item?.key,
        }));
        setScalesData(mappedData);
      })
      .catch((error) => console.error("Error fetching scales data:", error))
      .finally(() => setLoading(false));
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (admissionId) {
      getScalesData();
    }
  }, [admissionId]);

  return (
    <>
      {isModalVisible && (
        <ScaleModal
          scaleKey={selectedScale}
          isVisible={isModalVisible}
          onClose={handleCloseModal}
          data={selectedScaleData}
          patientData={patientData}
        />
      )}

      <UiSectionCard
        title="Progress Scales"
        className="progress-scales-surface"
        bodyClassName="progress-scales-body"
      >
        {loading ? (
          <LoadingIndicator message="Loading scales data, please wait..." />
        ) : (
          <Row
            gutter={[16, 16]}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 20px",
            }}
          >
            {scalesData?.length > 0 &&
              scalesData.map((item, index) => (
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  key={index}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                >
                  <Space className="progress-scale-card">
                    <UiButton
                      className="progress-scale-btn"
                      variant="ghost"
                      size="md"
                      onClick={() => handleBtnClick(item.key)}
                    >
                      {item.displayKey}
                    </UiButton>
                    <p className="progress-scale-count">{`Count: ${
                      item?.count || 0
                    }`}</p>
                  </Space>
                </Col>
              ))}
          </Row>
        )}
        {scaleLoading && <LoadingOverlay />}
      </UiSectionCard>
    </>
  );
};

export default ProgressScales;
